import { render, staticRenderFns } from "./PopupStoryCardTopBar.vue?vue&type=template&id=0ed241e3&"
import script from "./PopupStoryCardTopBar.vue?vue&type=script&lang=js&"
export * from "./PopupStoryCardTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports